import { useLocalStorage } from '@/hooks/useStorage';

export const classes = {
  overlay:
    'w-[94vw] max-w-[1450px] px-6 py-4 gap-4 flex flex-col h-full overflow-hidden',
  viewer: 'flex w-full grow overflow-hidden',
};

export function useTimelineSettings(defaultOpen = false) {
  return useLocalStorage('fileTimelineSettings', defaultOpen, true);
}
